import React,{Fragment} from 'react';
import {AppBar,makeStyles,Toolbar,Typography,Button} from '@material-ui/core';
//import logo from "../images/logo1.png"
import logo2 from "../images/logo2.png"
//import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles(theme =>({
    offset: theme.mixins.toolbar,
    menuButton:{
        marginRight: theme.spacing(1)
    },
    title:{
        flexGrow: 1
    }
}));

const Header = () => {
    const clase = useStyles();
    return ( 
        <Fragment>
            <AppBar>
                <Toolbar>
                    {/* <IconButton color="inherit" aria-label="menu" className={clase.menuButton}>
                        <MenuIcon />
                    </IconButton> */}
                    <img src={logo2} alt="Logo de la empresa" width="70" style={{
                        marginRight:20
                    }}></img>
                    <Typography variant='h6' className={clase.title}>
                        Lineas Áereas Suramericanas
                        
                    </Typography>
                    <Button
                        variant="text"
                        color="inherit"
                        href="https://lascargo.co/"
                    >HOME</Button>
                </Toolbar>
            </AppBar>
            <div className={clase.offset}></div>
        </Fragment>

    );
}
 
export default Header;